/* eslint
    no-async-promise-executor: "warn",
    dot-notation: "off"
*/

import { IDataMapper, IEasyfyEvent, IEasyfyEventExporter } from '@shared/easyfy.events/easyfy.eventdata';

/* Ga4 Exporter class */
export class Ga4EventExporter implements IEasyfyEventExporter {
  mapper: IDataMapper;

  WithMapper(mapper: IDataMapper): void {
    this.mapper = mapper;
  }

  RegisterEvent(event: IEasyfyEvent): Promise<any> {
    return new Promise<void>(async (resolve) => {
      if (!this.mapper) return;
      const eventData = this.mapper.MapEventData(event);
      await this.PushToDataLayer(eventData);
      resolve();
    });
  }

  async PushToDataLayer(ga4Event: any): Promise<any> {
    return new Promise<void>(async (resolve) => {
      if (ga4Event) {
        window['dataLayer'] = window['dataLayer'] || [];
        window['dataLayer'].push({ ecommerce: null });
        window['dataLayer'].push(ga4Event);
      }
      resolve();
    });

    // console.group('%c GA DataLayer ', 'color: #bada55');
    // console.dir(window['dataLayer']);
    // console.groupEnd();
  }
}
